import { render, staticRenderFns } from "./consumer-selector.vue?vue&type=template&id=bb588660"
import script from "./consumer-selector.ts?vue&type=script&lang=js&external"
export * from "./consumer-selector.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports